module.exports = __webpack_public_path__ + "img/ring_g_skip_1_0.12a4b873.png";